import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-user-details',
    templateUrl: './userDetails.component.html',
    styleUrls: ['./userDetails.component.scss']
})
export class UserDetailsComponent implements OnInit {

    constructor(private title: Title, private translate: TranslateService) { }

    ngOnInit(): void {
        this.translate.get('title_my_data').subscribe({
            next: (title) => {
              this.title.setTitle(title);
            }
          });
     }

}
